import { Form, Grid, message } from 'antd';
import { Modal } from 'components';
import { UserInfoFormItems } from 'features/users/components/modals/user-info-form-items';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import {
  UserFormField,
  UserFormValues,
} from 'features/users/components/users-filter-form';
import { useCreateUser } from 'features/users/use-cases/create-user';
import { useGetClientsServiceList } from 'features/users/use-cases/get-management-services';
import { useUserContext } from 'features/users/user-context';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const { useBreakpoint } = Grid;
export const AddAdminUserModal = ({ onClose }: { onClose: () => void }) => {
  const formName = 'add-user-form';
  const screens = useBreakpoint();
  const { user } = useUserContext();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [fileList, setFileList] = useState<any[]>([]);
  const [previewImage, setPreviewImage] = useState<string>('');
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [form] = Form.useForm<UserFormValues>();
  const { t } = useTranslation();
  const { isLoading, mutate } = useCreateUser();
  const parmas = {
    CompanyId: user?.CompanyId,
    // ClientId: ids,
  };
  const getUsersListQueryResponse = useGetClientsServiceList(parmas, {
    retry: false, // Disable retry if the query fails
  });
  const [categoryChecks, setCategoryChecks] = useState<any>({});
  const [subCategoryChecks, setSubCategoryChecks] = useState<any>({});
  const [classCategoryChecks, setClassCategoryChecks] = useState<any>({});
  const getInitialValues = {
    [UserFormField.Role]: undefined,
    [UserFormField.Email]: undefined,
  };
  const handlePayloadSet = () => {
    const payload: { ServiceId: string; categoryName: string }[] = []; // Initialize payload array
    getUsersListQueryResponse?.data?.data?.rc.forEach((category: any) => {
      // Check if the main category switch is checked
      if (categoryChecks[category.Id]) {
        // Include the main category if its switch is checked
        payload.push({ ServiceId: category.Id } as any);

        category.SubCategoryList?.forEach((subCategory: any) => {
          // Include subcategory only if its switch is checked
          if (subCategoryChecks[subCategory.Id]) {
            payload.push({ ServiceId: subCategory.Id } as any);
          }

          subCategory.ClassCategoryList?.forEach((classCategory: any) => {
            // Include class category only if its switch is checked
            if (classCategoryChecks[classCategory.Id]) {
              payload.push({ ServiceId: classCategory.Id } as any);
            }
          });
        });
      } else {
        // If the main category switch is unchecked, skip it along with its subcategories and class categories
        category.SubCategoryList?.forEach((subCategory: any) => {
          if (subCategoryChecks[subCategory.Id]) {
            payload.push({ ServiceId: subCategory.Id } as any);
          }

          subCategory.ClassCategoryList?.forEach((classCategory: any) => {
            if (classCategoryChecks[classCategory.Id]) {
              payload.push({ ServiceId: classCategory.Id } as any);
            }
          });
        });
      }
    });

    // Set the payload for further processing
    return payload;
  };
  const handleUpdate = (formValues: any) => {
    try {
      const file = fileList[0]?.originFileObj;
      if (file == undefined) {
        return message.error('Please Upload Profile');
      }
      const formData = new FormData();
      formData.append('UserName', formValues.Name);
      formData.append('RoleId', formValues.RoleId);
      formData.append('CompanyId', user?.CompanyId);
      formData.append('Email', formValues.Email);
      formData.append('file', file); // Include the entire file object
      formData.append('FileName', file.name);
      if (formValues?.SendMailAccess) {
        formData.append('SendMailAccess', formValues.SendMailAccess);
      } else {
        formData.append('SendMailAccess', 'false');
      }
      const payload = handlePayloadSet();
      formData.append('ServiceListTemp', JSON.stringify(payload));
      mutate(formData, {
        onSuccess: (data: any) => {
          if (data?.rs == 1) {
            message.success('User Created Successfully');
            onClose();
          } else {
            message.error(data?.rm);
          }
        },
      });
    } catch (error) {
      console.error('Error updating brand:', error);
    }
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        title={t('usermanagement.addClient.label')}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={t('adminUsers.addNewUser')}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{
          form: formName,
          loading: isLoading,
        }}
        maskClosable={false}
      >
        <Form<UserFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          initialValues={getInitialValues}
          onFinish={handleUpdate}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
          disabled={isLoading}
        >
          <UserInfoFormItems
            fileList={fileList}
            setFileList={setFileList}
            previewImage={previewImage}
            setPreviewImage={setPreviewImage}
            previewOpen={previewOpen}
            setPreviewOpen={setPreviewOpen}
            getUsersListQueryResponse={getUsersListQueryResponse}
            categoryChecks={categoryChecks}
            setCategoryChecks={setCategoryChecks}
            subCategoryChecks={subCategoryChecks}
            classCategoryChecks={classCategoryChecks}
            setSubCategoryChecks={setSubCategoryChecks}
            setClassCategoryChecks={setClassCategoryChecks}
          />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
